'use strict';

var jsxRuntime = require('react/jsx-runtime');
var material = require('@mui/material');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const DefaultTextField = (props)=>{
    if (props.type === 'hidden') {
        return /*#__PURE__*/ jsxRuntime.jsx("input", {
            type: "hidden",
            value: `${props.value}`,
            name: props.name,
            id: props.id
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsx(material.TextField, _extends({
        variant: "outlined",
        fullWidth: true
    }, props));
};

exports.DefaultTextField = DefaultTextField;
